export const LEVELS = [
  { name: 'Explorer', min: 0, max: 180, color: '#008080', emoji: '🔍' },
  { name: 'Adventurer', min: 181, max: 360, color: '#F5A623', emoji: '🗺️' },
  { name: 'Scholar', min: 361, max: 540, color: '#1a2456', emoji: '📚' },
  { name: 'Sage', min: 541, max: 720, color: '#7c3aed', emoji: '🧙' },
  { name: 'Luminary', min: 721, max: 900, color: '#dc2626', emoji: '💡' },
  { name: 'Master', min: 901, max: 1079, color: '#0891b2', emoji: '🏆' },
  { name: 'Knowble', min: 1080, max: 999999, color: '#F5A623', emoji: '⭐' },
];

const dice = (seed, bg = 'b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf') =>
  `https://api.dicebear.com/7.x/adventurer/svg?seed=${seed}&backgroundColor=${bg}&radius=50`;

export const CHARACTERS = {
  ouistiti: {
    key: 'ouistiti', name: 'Ouistiti', role: 'The Curious Scientist',
    description: 'Loves experiments, magnifying glasses, and asking "why?"',
    persona: 'a curious science-loving monkey who inspires with wonder',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/wingman/3a8ba598-3c82-4f0f-b65d-7eeba4624db1/attachments/3ca5813d483446458c08560aedc33379_image.bin',
  },
  stupidopoulos: {
    key: 'stupidopoulos', name: 'Stupidopoulos', role: 'The Brave Explorer',
    description: 'Suit-and-map bear ready for any quest across the globe',
    persona: 'a bold geography-loving bear who inspires courage and adventure',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/wingman/3a8ba598-3c82-4f0f-b65d-7eeba4624db1/attachments/813b4e2a336843e3829f1477c873acbb_image.bin',
  },
  stupidopoulou: {
    key: 'stupidopoulou', name: 'Stupidopoulou', role: 'The Studious Note-Taker',
    description: 'Always has the best notes and the sharpest questions',
    persona: 'a warm literature-loving rabbit who inspires with words and care',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/wingman/3a8ba598-3c82-4f0f-b65d-7eeba4624db1/attachments/3b11c767e27748a7a5480d8c5e8813fb_image.bin',
  },
  patapouf: {
    key: 'patapouf', name: 'Patapouf', role: 'The Adventurous Hiker',
    description: 'Backpack loaded, ready for any learning trail',
    persona: 'a warm history-loving hippo who inspires with tales of civilizations',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/wingman/3a8ba598-3c82-4f0f-b65d-7eeba4624db1/attachments/e3a446e97d064818b9f4f83b1a039925_image.bin',
  },
  luna: {
    key: 'luna', name: 'Luna', role: 'Young Astronaut',
    description: 'Curious about the stars and every "how does it work?"',
    persona: 'a curious young astronaut who loves space and asks great questions',
    image: dice('luna-astronaut'),
  },
  theo: {
    key: 'theo', name: 'Theo', role: 'Young Athlete',
    description: 'Discipline, teamwork, and one more rep',
    persona: 'a determined young athlete who inspires discipline and effort',
    image: dice('theo-athlete'),
  },
  mira: {
    key: 'mira', name: 'Mira', role: 'Young Musician',
    description: 'Creativity that turns notes into stories',
    persona: 'a creative young musician who inspires expression and practice',
    image: dice('mira-musician'),
  },
  kai: {
    key: 'kai', name: 'Kai', role: 'Young Engineer',
    description: 'Breaks big problems into tiny ones',
    persona: 'an analytical young engineer who inspires problem-solving',
    image: dice('kai-engineer'),
  },
  zoe: {
    key: 'zoe', name: 'Zoe', role: 'Nature Explorer',
    description: 'Adventurer of forests, rivers and wild ideas',
    persona: 'an adventurous young naturalist who inspires courage in the wild',
    image: dice('zoe-nature'),
  },
  arion: {
    key: 'arion', name: 'Arion', role: 'Young Entrepreneur',
    description: 'Bold ideas, one small step at a time',
    persona: 'a bold young entrepreneur who inspires leadership and action',
    image: dice('arion-entrepreneur'),
  },
};

export const TIER_META = {
  bronze:  { label: 'Bronze Week',  emoji: '🥉', color: '#cd7f32' },
  silver:  { label: 'Silver Week',  emoji: '🥈', color: '#a3a3a3' },
  gold:    { label: 'Gold Week',    emoji: '🥇', color: '#F5A623' },
  perfect: { label: 'Perfect Week', emoji: '🌟', color: '#008080' },
};
